import { api, HttpError } from '../api/client.js';

export function renderForgotPassword(root: HTMLElement): void {
  root.innerHTML = `
    <div class="auth-shell">
      <div class="auth-card">
        <img src="/img/ui/title.webp" alt="Rex Mortis" style="display:block; margin: 0 auto var(--s-3) auto; width: 280px; max-width: 90%; height: auto;" />
        <h1 style="text-align:center; margin: 0 0 var(--s-1) 0;">Recover by Raven</h1>
        <p class="subtitle" style="text-align:center;">— A scroll sent to thy listed inbox —</p>

        <div id="msg" class="alert success" hidden></div>
        <div id="err" class="alert danger" hidden></div>

        <form id="forgotForm" autocomplete="on">
          <div class="field">
            <label for="email">Email address</label>
            <input id="email" name="email" type="email" required autocomplete="email" />
          </div>
          <p class="auth-meta" style="margin-bottom: var(--s-3); font-style: italic;">
            We will dispatch a reset link if an account with this address exists. The link wanes after 60 minutes.
          </p>
          <button class="btn" type="submit" id="submit">Send reset scroll</button>
        </form>

        <p class="auth-meta">
          Remembered it after all? <a href="#/login">Return to the gate</a>.
        </p>
      </div>
    </div>
  `;

  const form = root.querySelector<HTMLFormElement>('#forgotForm')!;
  const msgBox = root.querySelector<HTMLDivElement>('#msg')!;
  const errBox = root.querySelector<HTMLDivElement>('#err')!;
  const submit = root.querySelector<HTMLButtonElement>('#submit')!;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    msgBox.hidden = true;
    errBox.hidden = true;
    submit.disabled = true;
    submit.textContent = 'Dispatching the raven…';

    const email = (form.elements.namedItem('email') as HTMLInputElement).value;

    try {
      await api.forgotPassword(email);
      // Server always returns 204 regardless of whether the account exists.
      msgBox.textContent =
        'If an account exists for that address, a reset scroll is on its way. Check thy inbox (and the spam pile).';
      msgBox.hidden = false;
      form.reset();
    } catch (err) {
      const msg = err instanceof HttpError ? err.message : 'Could not send the raven. Try again shortly.';
      errBox.textContent = msg;
      errBox.hidden = false;
    } finally {
      submit.disabled = false;
      submit.textContent = 'Send reset scroll';
    }
  });
}
